import axios from "axios";
import { API_URL } from "../index";

// FE-84: Services.js'ten taşındı (9 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
const servisGenel = {

  // Genel SMS gönderimi (flow/send-sms → {message, phone}). OTP mesajını FE hazırlar.
  SendSms(token, phone, message) {
    return axios({
      method: "post",
      url: `${API_URL}flow/send-sms`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        message: message,
        phone: phone
      },
    });
  },
  GetCities(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-cities`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },
  GetTowns(token, cityCode) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-towns`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        cityCode: cityCode
      }
    });
  },
  GetDistricts(token, townCode) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-districts`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        townCode: townCode
      }
    });
  },
  GetFAQ(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-faq`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        language: "tr"
      }
    });
  },
  // İşten ayrılan yöneticiler (status=9) varsayılan olarak DÖNMEZ (müşteri temsilcisi
  // seçimleri); Yetkilendirme sayfası onları da listelemek için includeLeft gönderir.
  GetAllAdmins(token, { includeLeft = false } = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-users`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: includeLeft ? { type: "admin", includeLeft: 1 } : { type: "admin" }
    });
  },

  GetChannels(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-communication-channels`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  // Troy Depo komisyon oranları — hizmet tipi (depolama/nakliye) başına ayrı tutulur.
  // Okuma: admin her firmayı, merchant kendi firmasını. Yazma yalnız admin.
  GetCommissionRates(token, corporationId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-commission-rates`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { corporationId },
    });
  },

  SetCommissionRate(token, { corporationId, serviceType, commissionRate, kdvIncluded, note }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-commission-rate`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: {
        corporationId,
        serviceType,
        commissionRate,
        kdvIncluded: kdvIncluded ? 1 : 0,
        note: note || "",
      },
    });
  },
};

export default servisGenel;
